<template>
  <div v-show="showProductWatchModal" class="modal-mask" transition="modal">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header">
          <slot name="header">Класс</slot>
        </div>

        <div class="modal-body">
          <b-tabs
            v-if="product.translations && product.translations.length > 0"
            content-class="mt-3"
            fill
            style="margin: 20px 0; overflow-x: hidden; max-height: 500px"
          >
            <b-tab
              v-for="translation in product.translations"
              :title="translation.locale"
              active
              :key="translation.id"
            >
              <div class="form-group">
                <label>Наименование</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="translation.title"
                  disabled
                />
              </div>
            </b-tab>
            <b-tab v-if="product.language" :title="product.language" active>
              <div class="form-group">
                <label
                  >Наименование свойства
                  <span class="btn btn-danger m-0 p-0">новое</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :value="product[product.language + '_title']"
                  disabled
                />
              </div>
              <div class="form-group">
                <label>
                  Описание свойства
                  <span class="btn btn-danger m-0 p-0">новое</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :value="product[product.language + '_comment']"
                  disabled
                />
              </div>
            </b-tab>
          </b-tabs>
          <div v-else>
            <div class="form-group">
              <label>Наименование</label>
              <input
                type="text"
                class="form-control"
                v-model="product.title"
                disabled
              />
            </div>
          </div>
          <div class="form-group">
            <label>Код</label>
            <input
              type="text"
              class="form-control"
              v-model="product.code"
              disabled
            />
          </div>
          <div class="form-group">
            <label>Единица измерения</label>
            <select class="form-control" disabled>
              <template v-for="(unit, index) in units">
                <option
                  v-if="unit.id === product.unit_id"
                  :selected="unit.id === product.unit_id"
                  :key="index"
                >
                  {{ unit.title }}
                </option>
              </template>
            </select>
          </div>
          <div class="form-group" v-if="product.type">
            <label>Тип</label>
            <select class="form-control" disabled>
              <option
                v-for="(type, index) in types"
                :selected="type.val === product.type"
                :key="index"
                :disabled="type.val !== product.type"
              >
                {{ type.name }}
              </option>
            </select>
          </div>
          <div class="alert alert-danger" v-if="comment">
            <b>Комментарий:</b> {{ comment }}
          </div>
        </div>

        <div class="modal-footer">
          <slot name="footer">
            <button
              class="modal-button btn btn-danger"
              @click="updateTab('update', { modal: 'product', visible: false })"
            >
              Закрыть
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { funcs } from "@/_helpers/_sumple_funcs";

export default {
  props: {
    showProductWatchModal: false,
    product: {},
    units: [],
    comment: null,
  },
  data() {
    return {
      types: funcs.giveProductTypes(),
    };
  },
  watch: {
    product: {
      handler: "productHandler",
    },
  },
  methods: {
    productHandler(el) {
      if (typeof this.product.unit_id === "string") {
        this.product.unit_id = funcs.getNumberFromString(this.product.unit_id);
      }
      if (typeof this.product.expense_id === "string") {
        this.product.expense_id = funcs.getNumberFromString(
          this.product.expense_id
        );
      }
      if (typeof this.product.type === "string") {
        this.product.type = funcs.getNumberFromString(this.product.type);
      }
    },
    updateTab(event = "update", spec) {
      this.$emit(event, spec);
      // console.log(this.specification.fields);
    },
    mounted() {
      console.log("product", this.product);
    },
  },
};
</script>

<style scoped></style>
